<template>
  <TransitionRoot as="template" :show="props.isOpen">
    <Dialog class="relative z-30" @close="emits('close-dialog')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-neutral_950 bg-opacity-30 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-2xl bg-neutral_700 shadow-xl transition-all w-full max-w-[707px] px-4 sm:px-6 md:px-8 py-6 flex flex-col gap-2 sm:gap-4"
            >
              <div class="flex items-center gap-2">
                <UserPicture size="sm" gap="gap-2" :user="props.review.user" />
                <p class="text-[14px] font-medium text-neutral_200 leading-[150%]">
                  {{ calculateTimeAgo(props.review.created_at) }}
                </p>
              </div>
              <div class="h-px w-full bg-neutral_500" />
              <BettingShopGradeSection
                v-for="(grade, index) in props.review.values"
                :key="index"
                place="dialog"
                :grade="grade"
              />
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  review: {
    type: Object,
    required: true
  }
});
const emits = defineEmits(['close-dialog']);
const { calculateTimeAgo } = useTimeFunctions();
</script>
